import { FounderQuote } from '@/components/landing/FounderQuote';
import { Icon } from '@/components/Icon';
import { useT } from '@/lib/useLang';

export function Focus() {
  const t = useT();

  return (
    <section id="results" className="nz-section">
      <div className="nz-split">
        <div>
          <div className="nz-eyebrow">{t.focusEyebrow}</div>
          <h2 className="nz-h2">{t.focusH2}</h2>
          <p className="nz-lead">{t.focusP}</p>
        </div>
        <FounderQuote bare />
      </div>

      <div className="nz-focus__grid">
        {t.focusItems.map((item) => (
          <div className="nz-focus__item" key={item.title}>
            <div className="nz-focus__mark">
              <Icon name={item.icon} className="nz-focus__icon" />
            </div>
            <div className="nz-focus__title">{item.title}</div>
            <div className="nz-focus__body">{item.body}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
